var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBigarrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 23,
    viewBox: "0 0 70 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 10C1.17157 10 0.5 10.6716 0.5 11.5C0.5 12.3284 1.17157 13 2 13V11.5V10ZM69.0682 12.5607C69.654 11.9749 69.654 11.0251 69.0682 10.4393L59.5223 0.893398C58.9365 0.307611 57.9868 0.307611 57.401 0.893398C56.8152 1.47919 56.8152 2.42893 57.401 3.01472L65.8863 11.5L57.401 19.9853C56.8152 20.5711 56.8152 21.5208 57.401 22.1066C57.9868 22.6924 58.9365 22.6924 59.5223 22.1066L69.0682 12.5607ZM2 11.5V13H68.0076V11.5V10H2V11.5Z",
    fill: "#45894D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigarrow);
export default __webpack_public_path__ + "static/media/bigarrow.21728e876c2c69b8c650acf9d852ba1f.svg";
export { ForwardRef as ReactComponent };